import { makeStyles } from '@mui/styles';
import { isRtl } from '../../utils/isrtl';

const logosHeight = 42;

export default makeStyles(() => ({
  form: {
    height: '100vh',
    '@media (min-width: 768px)': {
      height: 'auto',
      width: 540,
      margin: '70px auto 0 auto',
    },
  },
  formContainer: {
    height: '100%',
    padding: '24px 24px 0',
    backgroundColor: '#fff',
    '@media (min-width: 768px)': {
      borderRadius: 8,
      border: '1px solid #BABABA',
      padding: '24px',
    },
    '@media (max-width: 767px)': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  },
  formTitleContainer: {
    height: 72,
    display: 'flex',
    justifyContent: (props) => (isRtl(props) ? 'flex-end' : 'flex-start'),
    alignItems: 'center',
    paddingRight: 24,
    paddingLeft: 24,
    borderBottomWidth: 0.1,
    borderBottomStyle: 'solid',
    borderBottomColor: ' #BABABA',
    boxSizing: 'border-box',
    margin: '-24px -24px 24px -24px',
  },
  formTitle: {
    fontSize: 18,
  },
  fieldsWrapper: {},
  formFieldContainer: {
    backgroundColor: '#F3F3F3',
    display: 'flex',
    borderStyle: 'none',
    borderRadius: 10,
    height: 41,
    alignItems: 'center',
    paddingInlineStart: '8px',
    paddingInlineEnd: '12px',
    flexDirection: (props) => (isRtl(props) ? 'row-reverse' : 'row'),
  },

  formField: {
    fontWeight: 600,
    width: '100%',
    height: '100%',
    backgroundColor: '#F3F3F3',
    alignSelf: (props) => (isRtl(props) ? 'flex-end' : 'flex-start'),
    borderStyle: 'none',
    borderRadius: 10,
    boxSizing: 'border-box',
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),

    '&:active': {
      outline: 'none',
    },

    '&:focus': {
      outline: 'none',
    },

    '&::placeHolder': {
      color: '#BABABA',
    },
    '&:required:invalid': {
      borderColor: '#FF002B',
      borderWidth: 1,
      backgroundColor: 'white',
    },
  },
  formSmallRow: { width: '49%', display: 'flex', flexDirection: 'column' },
  cardNumberField: {
    paddingLeft: (props) => (isRtl(props) ? 0 : 45),
    paddingRight: !((props) => isRtl(props)) ? 0 : 45,
  },

  cardNumberLogo: {
    position: 'absolute',
    width: 32,
    height: 20,
    marginTop: 15,
    paddingRight: (props) => (isRtl(props) ? 12 : 0),
    paddingLeft: !((props) => isRtl(props)) ? 0 : 12,
    borderRadius: 0,
  },
  cardLogoBackground: {
    position: 'absolute',
    backgroundColor: '#BABABA',
    width: 32,
    height: 20,
    marginLeft: (props) => (isRtl(props) ? -12 : 12),
    marginRight: (props) => (isRtl(props) ? 12 : 0),
    borderRadius: 3,
    transform: 'translateY(50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cardNumberLogoContainer: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: (props) => (isRtl(props) ? 'flex-end' : 'flex-start'),
  },

  formLabel: {
    fontSize: 14,
    margin: '0 0 8px',
    fontWeight: 500,
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),
  },
  firstLabel: {
    marginTop: 0,
  },
  rememberMeText: {
    fontSize: 12,
    fontWeight: 500,
  },
  formRow: {
    width: '100%',
    display: 'flex',
    flexDirection: (props) => (isRtl(props) ? 'row-reverse' : 'row'),
    justifyContent: 'space-between',
  },
  submitButton: {
    width: '100%',
    height: 52,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#4CAF50',
    color: '#fff',
    borderRadius: 12,
    borderStyle: 'none',
    marginTop: '15px',
    fontSize: 16,
    fontWeight: 500,
    cursor: 'pointer',
    '&:disabled': {
      backgroundColor: '#E6E6E6',
      color: '#C6C6C6',
      cursor: 'not-allowed',
    },
  },
  totalTextContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: (props) => (isRtl(props) ? 'row-reverse' : 'row'),
    justifyContent: 'space-between',
    fontWeight: 500,
    '& + &': {
      marginTop: '14px',
    },
  },
  totalText: {
    fontSize: 14,
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),
    unicodeBidi: 'plaintext',
    fontWeight: 'inherit',
  },
  totalSpan: {
    fontSize: 12,
    color: '#949494',
    fontWeight: 400,
  },
  logosContainer: {
    padding: '10px 0',
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    width: '100%',

    '@media (min-width: 768px)': {
      bottom: '-90px',
    },

    '@media (max-width: 767px)': {
      transform: 'translateY(calc(-100% - 20px))',
    },

    '& > * + *': {
      marginInlineStart: '16px',
    },
  },
  logo: { width: 48, height: 24, marginRight: 16 },
  submitContainerMobile: {
    backgroundColor: '#f7f7f7',
    padding: '16px 24px',
    marginTop: logosHeight,
    margin: `${logosHeight}px -24px 0 -24px`,
  },
  fieldError: {
    borderColor: '#FF002B',
    borderStyle: 'solid',
    borderWidth: 0.5,
  },
  errorMessage: {
    color: '#FF002B',
    height: 5,
    margin: '5px 0',
    fontSize: 12,
    fontWeight: '500',
    textAlign: (props) => (isRtl(props) ? 'right' : 'left'),
  },
  logoTypeWrapper: {
    display: 'flex',
  },
  promotedBankDiscount: {
    maxWidth: '26ch',
    lineHeight: '1.4',
  },
}));
